/**
 * Canonical DOM anchor id for a group forum topic card (MWBI-910).
 *
 * The group-activity email builds its deep-link fragment with
 * `encodeURIComponent(topicDocumentId)` (see cms/server/src/api/email/templates/
 * links.ts::groupDiscussionUrl). The rendered element id, the card's hash
 * comparison, and ForumTab's `getElementById` lookup must all use the SAME
 * encoded form -- otherwise a documentId containing a reserved character
 * (`?`, `#`, `/`, space) would render as `forum-<raw>` while the URL hash is
 * `#forum-<encoded>`, the two would never match, and the deep link would
 * silently no-op. Strapi documentIds are lowercase alphanumeric today (so this
 * is effectively a no-op), but keeping the frontend symmetric with the backend
 * contract is defense-in-depth against future id drift.
 */
export function forumAnchorId(documentId: string): string {
  return `forum-${encodeURIComponent(documentId)}`;
}
